import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  cancelReasons: [],
  allCancelReasons: [],
  totalPages: 0,
  totalRecords: 0,
  cancelReason: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_7: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_CancelReasons(state, cancelReasons) {
    state.cancelReasons = cancelReasons.items;
    state.totalPages = cancelReasons.totalPages;
    state.totalRecords = cancelReasons?.totalRecords ?? 0;
  },
  SET_AllCancelReasons(state, cancelReasons) {
    state.allCancelReasons = cancelReasons;
  },
  SET_CancelReason(state, cancelReason) {
    state.cancelReason = cancelReason;
  },
};
const actions = {
  errorCancelReason({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllCancelReasons({ commit, dispatch, rootState }) {
    return apiClient
      .get('/CancelReasons/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllCancelReasons', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCancelReason', error);
      });
  },
  addCancelReason({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/CancelReasons', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCancelReason', error);
      });
  },
  getCancelReason({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/CancelReasons/ById?cancelReasonId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_CancelReason', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCancelReason', error);
      });
  },
  editCancelReason({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/CancelReasons/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCancelReason', error);
      });
  },
  deleteCancelReason({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/CancelReasons/Remove?cancelReasonId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCancelReason', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
